import React, { useRef } from 'react'
import { UploadImage, UploadPanel } from '../../styles'

import PlusIcon from 'svg/plus-outline.svg'
import CreateCollectionsModal, {
  CreateCollectionsModalApi,
  getCreatedCollectionUrl,
} from 'apps/saatchi/collection/layouts/Modal'

const Upload = (props: Record<string, any>) => {
  const { imageContentHeight, uploadImageUrl } = props
  const createCollectionsModalRef = useRef<CreateCollectionsModalApi>(null)

  const handleOpenCreateCollectionsModal = () => {
    createCollectionsModalRef.current?.handleOpenModal()
  }

  const handleCreateCollectionOnSuccess = (
    payload: Record<string, any>,
    formData: Record<string, any>
  ) => {
    const { href } = window.location
    const userId = href.split('/').pop() ?? ''
    const newLocation = getCreatedCollectionUrl({ payload, formData, userId })

    window.location.assign(newLocation)
  }

  return (
    <>
      <div onClick={handleOpenCreateCollectionsModal} style={{ cursor: 'pointer' }}>
        <UploadPanel styles={`min-height: ${imageContentHeight}px;`}>
          <UploadImage alt='Saatchi Art Artist Uploader' image={uploadImageUrl}>
            <PlusIcon />
            <h6 className='defaultTypographyH6'>Create a New Collection</h6>
          </UploadImage>
        </UploadPanel>
      </div>
      <CreateCollectionsModal
        ref={createCollectionsModalRef}
        onSuccess={handleCreateCollectionOnSuccess}
      />
    </>
  )
}

export default Upload
